import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

/**
 * Renders the preloader
 */
const Loader = ({ isOverlay }) => {
  const modifierClassList = useMemo(() => {
    const classes = [];
    if (typeof isOverlay !== 'undefined' && !isOverlay)
      classes.push('is-transparent');
    return classes;
  }, [isOverlay]);

  return (
    <div className={cx('preloader', modifierClassList.join(' '))}>
      <div className="status">
        <div className="bouncing-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;

Loader.propTypes = {
  isOverlay: PropTypes.bool,
};
